import { ListingTimeData } from '../../../components';
import { APIListingItem } from '../types';

/**
 * Maps over an API Listing's subStatus and selects the relevant date to pass through for rendering in listing card.
 */
export function mapTimingData(apiListing: APIListingItem): ListingTimeData {
  switch (apiListing.subStatus) {
    case 'Referred':
      return {
        type: 'bid',
        time: apiListing.endDate,
      };
    case 'MakeAnOffer':
      return {
        type: 'offer',
        time: apiListing.endDate,
      };
    case 'WaitingForPayment':
    case 'BuyerPaid':
    case 'SellerPaid':
      return {
        type: 'sold',
        time: apiListing.endDate,
      };
    case 'Auction':
    default:
      return apiListing.status === 'Unsold'
        ? {
            type: 'unsold',
            time: apiListing.endDate,
          }
        : {
            type: 'auction',
            time: apiListing.endDate,
          };
  }
}
